import { render } from "./EventsItem.vue?vue&type=template&id=6d9c5e7e&scoped=true"
import script from "./EventsItem.vue?vue&type=script&lang=js"
export * from "./EventsItem.vue?vue&type=script&lang=js"

import "./EventsItem.vue?vue&type=style&index=0&id=6d9c5e7e&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src1149623050/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d9c5e7e"]])

export default __exports__